import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import {
  selectActiveAddress,
  selectAddressesConfigData,
  selectCurrentAddressData,
  selectCurrentAddressErrors,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { updateAddressData, updateAddressesConfigData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import useModal from '@/shared/hooks/v2/useModal'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

const useLastHolderFields = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { country } = useSelector(selectAuthData)
  const { isEditable } = useFormStatus()
  const activeAddress = useSelector(selectActiveAddress)
  const { lastHolderData = {} } = useSelector(selectCurrentAddressData)
  const {
    last_holder_name: lastHolderName,
    last_holder_cf: lastHolderCf,
    last_holder_property_date: lastHolderPropertyDate = '',
  } = lastHolderData as any
  const errors = useSelector(selectCurrentAddressErrors)
  const { isOpen, openModal, closeModal } = useModal({ selector: selectAddressesConfigData, actionCreator: updateAddressesConfigData, modalKey: 'lastHolderFieldsModal' })

  // @ts-ignore
  const addressConfig = modulesConfig[country]?.address ?? {}
  const hidden = !addressConfig.lastHolderFields

  const updateAddress = (data: object) => {
    // @ts-ignore
    dispatch(updateAddressData({ data: { lastHolderData: { ...lastHolderData, ...data } }, id: activeAddress }))
  }

  return {
    t,
    errors,
    isEditable,
    lastHolderName,
    lastHolderCf,
    lastHolderPropertyDate,
    hidden,
    isOpen,
    openModal,
    closeModal,
    updateAddress,
  }
}

export default useLastHolderFields
